<script setup lang="ts">
import SliderBar from '@/components/common/slidebar.vue'
import { seaTurtleApiClauseInfoGetByTypePost } from '@/services/api/CommonApi'

const { t } = useLang()
useHead({
  title: t('common.b_tdk_title'),
  meta: [
    { name: 'keywords', content: t('common.b_tdk_keywords') },
    { name: 'description', content: t('common.b_tdk_description') },
    { name: 'author', content: t('common.b_author') },
    { name: 'copyright', content: t('common.b_company') },
  ],
})

const categoryId = ref('')
const pageName = ref('')
const pageContent = ref('')

onMounted(() => {
  setTimeout(() => {
    if (process.client) {
      seaTurtleApiClauseInfoGetByTypePost({
        agreementType: 2,
      }).then((res) => {
        pageName.value = res?.showName || ''
        pageContent.value = res?.clauseText || ''
      })
    }
  })
})
</script>

<template>
  <div class="content clearfix">
    <SliderBar path="privacy-policy" :category-id="categoryId" />
    <div class="right_main">
      <div class="show_con">
        <div class="title">
          {{ pageName }}
        </div>
        <div class="main_content">
          <p v-html="pageContent" />
          <!-- <ul class="privacy_ul">
            <li>
              <p class="policy_label_0">
                {{ t('privacypolicy.b_label_0') }}
              </p>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title01') }}
              </h4>
              <div class="privacy_info">
                <p>
                  {{ t('privacypolicy.b_label_01_1') }}
                  <b>{{ t('privacypolicy.b_label_01_2') }}</b>
                </p>
                <p>{{ t('privacypolicy.b_label_01_3') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title02') }}
              </h4>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_02_1') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_02_1_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_1_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_1_3') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_1_4') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_1_5') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_1_6') }}</li>
                </ul>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_02_2') }}</h4>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_02_3') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_02_3_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_3_1_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_3_1_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_3_1_3') }}</li>
                  <li>{{ t('privacypolicy.b_label_02_3_2') }}</li>
                </ul>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_02_4') }}</h4>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title03') }}
              </h4>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_03_1') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_03_1_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_3') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_4') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_5') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_6') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_7') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_8') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_9') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_10') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_11') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_12') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_1_13') }}</li>
                </ul>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_03_2') }}</h4>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_03_3') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_03_3_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_3') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_4') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_5') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_6') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_7') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_8') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_9') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_10') }}</li>
                  <li>{{ t('privacypolicy.b_label_03_3_11') }}</li>
                </ul>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title04') }}
              </h4>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_04_1') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_04_1_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_1_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_1_3') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_1_4') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_1_5') }}</li>
                </ul>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_04_2') }}</h4>
                <h4>{{ t('privacypolicy.b_label_04_2_subtitle') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_04_2_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_2_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_2_3') }}</li>
                </ul>
              </div>
              <div class="privacy_info">
                <h4>{{ t('privacypolicy.b_label_04_3') }}</h4>
                <h4>{{ t('privacypolicy.b_label_04_3_subtitle') }}</h4>
                <ul>
                  <li>{{ t('privacypolicy.b_label_04_3_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_04_3_2') }}</li>
                </ul>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title05') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_05_1') }}</p>
              </div>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_05_2') }}</p>
              </div>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_05_3') }}</p>
                <ul>
                  <li>{{ t('privacypolicy.b_label_05_3_1') }}</li>
                  <li>{{ t('privacypolicy.b_label_05_3_2') }}</li>
                  <li>{{ t('privacypolicy.b_label_05_3_3') }}</li>
                </ul>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title06') }}
              </h4>
              <div class="privacy_info">
                <p><b>{{ t('privacypolicy.b_label_06_1') }}</b></p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title07') }}
              </h4>
              <div class="privacy_info">
                <p>
                  {{ t('privacypolicy.b_label_07_1') }}
                  <b>{{ t('privacypolicy.b_label_07_2') }}</b>
                </p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title08') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_08_1') }}</p>
                <p>{{ t('privacypolicy.b_label_08_2') }}</p>
                <p>{{ t('privacypolicy.b_label_08_3') }}</p>
                <p>{{ t('privacypolicy.b_label_08_4') }}</p>
                <p>{{ t('privacypolicy.b_label_08_5') }}</p>
                <p>{{ t('privacypolicy.b_label_08_6') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title09') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_09_1') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title10') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_10_1') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title11') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_11_1') }}</p>
                <p>{{ t('privacypolicy.b_label_11_2') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title12') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_12_1') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title13') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_13_1') }}</p>
                <p>{{ t('privacypolicy.b_label_13_2') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title14') }}
              </h4>
              <div class="privacy_info">
                <p>{{ t('privacypolicy.b_label_14_1') }}</p>
              </div>
            </li>
            <li>
              <h4 class="privacy_title">
                {{ t('privacypolicy.b_title15') }}
              </h4>
              <div class="privacy_info">
                <p><b>{{ t('privacypolicy.b_label_15_1') }}</b></p>
              </div>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import url('@/assets/css/common/index.scss');
</style>
